











import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class RegLink extends Vue {
  @Prop({ type: String, default: '' })
  link: string;

  @Prop({ type: String, default: 'Записаться' })
  text: string;

  @Prop({ type: String, default: 'lime' })
  color: string;

  @Prop({ type: Boolean, default: false })
  wide: boolean;

  @Prop({ type: Boolean, default: false })
  block: boolean;

  get styles() {
    const color =
      this.color === 'lime' &&
      this.$store &&
      this.$store.state.regionProfile &&
      this.$store.state.regionProfile.colorBtnSuccess;
    return color
      ? { backgroundColor: `#${color}`, borderColor: `#${color}` }
      : {};
  }

  get classes() {
    return {
      [`reglink_${this.color}`]: true,
      [`reglink_wide`]: this.wide,
      [`reglink_block`]: this.block,
    };
  }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/regularLink/RegularLink.vue